import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { AttioNotesService } from 'dashboard409a/services/attio/AttioNotesService';
import type { AnalystNoteHistoryItem, AnalystNoteReferenceType } from './AnalystNotesHistoryPanel.types';

export const analystNotesHistoryQueryKey = (
  referenceType: AnalystNoteReferenceType,
  referenceId: string | number | undefined | null
) => ['analyst-notes-history', referenceType, referenceId] as const;

export const useAnalystNotesHistoryQuery = (
  referenceType: AnalystNoteReferenceType,
  referenceId: string | number | undefined | null
) => {
  const notesService = useMemo(() => new AttioNotesService(), []);
  const queryKey = useMemo(
    () => analystNotesHistoryQueryKey(referenceType, referenceId),
    [referenceType, referenceId]
  );

  return useQuery<AnalystNoteHistoryItem[]>({
    queryKey,
    enabled: referenceId !== undefined && referenceId !== null,
    retry: false,
    refetchOnWindowFocus: false,
    queryFn: () => {
      if (referenceId === undefined || referenceId === null) {
        return Promise.resolve([]);
      }
      return notesService.getNotesHistoryForReference(referenceType, referenceId);
    },
  });
};
